import { Modal, Table } from "react-bootstrap";
import { Fragment, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Loader from "react-loader-spinner";
import { X, VectorPen, Printer } from "react-bootstrap-icons";
import { setPopupMenu } from "../store/api/Modals";



const PopupMenu = (props) => {
    const dispatch = useDispatch();
    let height = 0;
    const close = () => {
        dispatch(setPopupMenu({ show: false }));
    }
    const popupMenu = useSelector(state => state.popup.popupMenu);
    const {title, show, menuItems,top, left} = popupMenu;
    return (
        <Modal className="popup" show={show} style={{ direction: "rtl", left:left - (window.innerWidth/2)-70, top: (top - height - ((menuItems? menuItems.length:1) * 30)) }} onHide={() => { }}>
            <Modal.Header style={{ backgroundColor: '#e40375', padding:"8px" }}>{title}<span style={{ cursor: "pointer" }} onClick={close}>
                <X size={20} /></span>
            </Modal.Header>
            <Modal.Body style={{padding:"8px"}}>
                {menuItems && menuItems.map((item, i) => {
                    return (<div className="popMenuItem" key={i} onClick={()=>{item.onClick();close();}}>{item.icon}{"  "+item.title}</div>)
                })}
            </Modal.Body>
        </Modal>
    )
}
export default PopupMenu;